import axios from 'axios';
import {config} from '../shared/app.config';
import store from '@/store/store';

const RESOURCE_NAME = '/webadmin/qr';

export default {
  generateQR (type, id) {
    return axios(`${config.webApiBase + RESOURCE_NAME  }/${  type  }/${  id}`, {
      method: 'GET',
      responseType: 'blob'
    });
  },
  redirectQR (id, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios(`${config.webApiBase + RESOURCE_NAME  }/${  id}`, {
      method: 'GET',
      headers: {
        'X-localization': language
      }
    });
  },
}
